import { addons } from '@storybook/manager-api';
import { create } from '@storybook/theming/create';
import { version } from '../package.json';

addons.setConfig({
  theme: create({
    base: 'light',
    brandTitle: `H1 Components v${version}`,
    brandUrl: 'https://github.com/H1-Card/lib-ui',
    brandImage: `${process.env.PUBLIC_URL}/h1-logo.png`
  }),
});
